"use strict";
/**
 * Admin API types for storefront placement option rules.
 * Scoped by landing page + product link (same rules apply wherever the product appears on that page).
 */
Object.defineProperty(exports, "__esModule", { value: true });
